import './styles.scss'
import React, { useState, useRef } from 'react'
import { useParams } from 'react-router-dom'
import useDraggableScroll from 'use-draggable-scroll'
import { I18n } from 'react-redux-i18n'

import { botConsole } from 'api'
import AddEditAssistant from './AddEditAssistant'
import { DotsOptionsSelector } from 'components/common'
import ModalDelete from 'components/ModalDelete'
import { getStaticImage } from 'utils/statics'

const Tabs = (props) => {
  const { setBotHeader, botHeader, assistants, setAssistants, selectAssistant } = props
  const { assistantId } = useParams()
  const tabsRef = useRef(null)
  const [isOptionsOpen, setIsOptionsOpen] = useState(false)
  const [isOpenAddEditModal, setIsOpenAddEditModal] = useState(false)
  const [isOpenDeleteModal, setIsOpenDeleteModal] = useState(false)
  const [assistantToEdit, setAssistantToEdit] = useState(null)
  const [assistantToDelete, setAssistantToDelete] = useState(null)
  const [removing, setRemoving] = useState(false)
  const [errorMessage, setErrorMessage] = useState()

  const { onMouseDown } = useDraggableScroll(tabsRef, { direction: 'horizontal' })

  const toggleOptions = () => setIsOptionsOpen(!isOptionsOpen)

  const toggleDeleteModal = (assistantId) => {
    assistantId ? setAssistantToDelete(assistantId) : setAssistantToDelete(null)
    if(isOptionsOpen) toggleOptions()
    if(!isOpenDeleteModal) setErrorMessage(null)
    setIsOpenDeleteModal(!isOpenDeleteModal)
  }
  const handleDelete = async () => {
    setErrorMessage(null)
    setRemoving(true)

    try {
      const result = await botConsole.deleteBot(assistantToDelete)
      if (result.status === 200) {
        const { data } = await botConsole.getVaList()
        setAssistants(data.result)
        toggleDeleteModal()
      }
    } catch (error) {
      setErrorMessage(I18n.t('botConsole_error_back_delete'))
    }

    setRemoving(false)
  }

  const toggleAddEditModal = (assistantId) => {
    assistantId ? setAssistantToEdit(assistantId) : setAssistantToEdit(null)
    if(isOptionsOpen) toggleOptions()
    setIsOpenAddEditModal(!isOpenAddEditModal)
  }

  return (
    <>
      <div ref={tabsRef} className='av-tabs' onMouseDown={onMouseDown}>
        {assistants.map((assistant, index) => (
          <div key={index} className={`av-tabs__item ${assistantId === assistant.consoleId ? 'av-tabs__item--active' : ''}`} onClick={() => selectAssistant(assistant.consoleId)}>
            <span className='av-tabs__title'>{assistant.name.length ? assistant.name : 'Global'}</span>
            {assistantId === assistant.consoleId ? (
              <DotsOptionsSelector
                isOpen={isOptionsOpen}
                toggle={toggleOptions}
                position='bottom'
                options={assistant.name.length ? ([
                  { name: I18n.t('dashboard_edit'), onClick: () => toggleAddEditModal(assistant.consoleId) },
                  { name: I18n.t('dashboard_delete'), onClick: () => toggleDeleteModal(assistant.consoleId) }
                ]) : ([
                  { name: I18n.t('dashboard_edit'), onClick: () => toggleAddEditModal(assistant.consoleId) }
                ])}
              />
            ) : null}
          </div>
        ))}
        <img className='av-tabs__add' src={getStaticImage('/icons/orange-brand/icon-add.svg')} alt='Add VA' onClick={() => toggleAddEditModal()}/>
      </div>
      {isOpenAddEditModal && assistantId === botHeader._id ? (
        <AddEditAssistant
          isOpenAddEditModal={isOpenAddEditModal}
          toggleAddEditModal={() => toggleAddEditModal()}
          assistantToEdit={assistantToEdit}
          setBotHeader={setBotHeader}
          botHeader={botHeader}
          assistants={assistants}
          setAssistants={setAssistants}

        />
      ) : null}
      <ModalDelete
        isOpen={isOpenDeleteModal}
        toggle={() => toggleDeleteModal()}
        header={I18n.t('botConsole_remove_assistant')}
        text1={I18n.t('botConsole_remove_assistant_title')}
        text2={I18n.t('dashboard_action-cannot-reversed')}
        assistantToDelete={assistantToDelete}
        event={handleDelete}
        isSubmitting={removing}
        errorMessage={errorMessage}
      />
    </>
  )
}

export default Tabs
